import { DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import _ from 'lodash';
import { useHomePageEditorContext } from '../provider';
import Description from './description';
import CreateMailProvider, { useCreateContext } from './provider';
import { BootstrapDialog, StyledActionContainer, StyledButtonCancel, StyledButtonSave } from './styles.css';
import { useMemo } from 'react';

function ContainerDialog() {
  return (
    <CreateMailProvider>
      <Component />
    </CreateMailProvider>
  );
}


function Component() {
  const { container, setContainer } = useHomePageEditorContext();
  const { onSubmit } = useCreateContext();

  const title= useMemo(() => {
    switch(container){
      default:
      case "subBlock1": 
        return "Edit Container 1";
      case "subBlock2": 
        return "Edit Container 2";
      case "subBlock3": 
        return "Edit Container 3";
    }
  },[container]);

  return (
    <BootstrapDialog
      fullWidth
      maxWidth="sm"
      open={!_.isEmpty(container)}
      onClose={() => setContainer("")} >
      <DialogTitle sx={{ m: 0, px: 4, pt: 3, borderBottom: 1, borderBottomColor: "#F1F5F9" }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Stack>
          <Description />
        </Stack>
      </DialogContent>
      <DialogActions>
        <StyledActionContainer>
          <StyledButtonCancel variant='outlined' onClick={() => setContainer("")} >CANCEL</StyledButtonCancel>
          <StyledButtonSave
            variant="contained"
            form="game-details-form"
            type="submit"
            onClick={onSubmit}
          >
            SAVE
          </StyledButtonSave>
        </StyledActionContainer>
      </DialogActions>
    </BootstrapDialog>
  );
}

export default ContainerDialog;